import React from 'react'
import Advfour from './Advfour';
import Advfoura from './Advfoura';
import Advone from './Advone';
import "./Home.css";
import Product from './Product';

export default function Home() {
    return (
        <div className="home">
            <div className="home_container">
                 <img  className="home_image"
                 src="https://m.media-amazon.com/images/I/619QIdx19yL._SX3000_.jpg"/>
                 
 
  <div className="home_row">
  <Advone/>
  <Advfour/>
  <Advfoura/>
                 </div>


                 <div className="home_row">
                     
                     <Product title='Acer Aspire 5 11th Gen Core i5 14-inch (35.56 cms)  ' price={54234}  image='https://m.media-amazon.com/images/I/71euQ6eHPYL._SL1500_.jpg' rating={4} />
                     <Product title="AmazonBasics 109 cm (43 inches) 4K Ultra HD Smart LED Fire TV AB43U20PS (Black)"price={29999}  image='https://m.media-amazon.com/images/I/71AqQyCMmeL._SL1240_.jpg' rating={4} />
                 </div>
                 <div className="home_row">
                 <Product title="realme Fashion Watch 3.56 cm  Large HD Color Display, Full Touch Screen, SpO2, Continuous Heart....
"price={4990}  image='https://m.media-amazon.com/images/I/71pYXdg9+IL._SL1500_.jpg' rating={3} />
                 <Product title="Whirlpool 1.5 Ton 3 Star Inverter Split AC (Copper, 1.5T MAGICOOL 3S COPR INVERTER, White)
3.8 out of 5 stars 2,389"price={29990}  image='https://m.media-amazon.com/images/I/61Vs-rdtqvL._SL1500_.jpg' rating={4} />
                 <Product title="Apple iPhone 11 (64GB) - White
"price={46999}  image='https://m.media-amazon.com/images/I/71QE00iB9IL._SL1500_.jpg' rating={5} />
                 </div>
                 <div className="home_row">
                     <Product title="Redmi 80 cm (32 inches) HD Ready Smart LED TV | L32M6-RA (Black) (2021 Model) | With Android 11" price={23490} image="https://m.media-amazon.com/images/I/71f-TfffHfL._SL1500_.jpg" rating={5}/>
                   
                 </div>
                 <div className="fashion">
          
          <img className="fastwoimg"  src="https://images-eu.ssl-images-amazon.com/images/G/31/img21/Fashion/N2SL/V2/WomenClothing/womens-clothing__01.jpg"/>
          </div>
          <div className="home_row">

<Product title='God Bless
Women' price={399}  image='https://m.media-amazon.com/images/I/712HeyuPFNL._AC_UL480_FMwebp_QL65_.jpg' rating={4} />
<Product title="Butterfly Tops for Women Stylish"price={459}  image='https://m.media-amazon.com/images/I/61tZjIlf3qL._AC_UL480_FMwebp_QL65_.jpg' rating={4} />
<Product title="Women's Regular Fit Fashion Vest "price={349}  image='https://m.media-amazon.com/images/I/71H1QZVBq6L._AC_UL480_FMwebp_QL65_.jpg' rating={4} />
<Product title="Women's Regular Fit Top"price={466}  image='https://m.media-amazon.com/images/I/81fTUodaQjL._AC_UL480_FMwebp_QL65_.jpg' rating={5} />
</div>
<div className="fashion">
<img className="fastwoimg "  src="https://images-eu.ssl-images-amazon.com/images/G/31/img21/Fashion/N2SL/V2/Men/mens-clothing__01.jpg"/>
</div>
<div className="home_row">

<Product title='White Regular Fit T-Shirt' price={649}  image='https://m.media-amazon.com/images/I/81sg7JxzMDL._AC_UL480_FMwebp_QL65_.jpg' rating={4} />
<Product title="Men's Regular fit Polo"price={728}  image='https://m.media-amazon.com/images/I/91jpRsTPpUL._AC_UL480_FMwebp_QL65_.jpg' rating={4} />
<Product title="Men's Slim Fit Casual Shirt "price={349}  image='https://m.media-amazon.com/images/I/81kJzDOwjNL._AC_UL480_FMwebp_QL65_.jpg' rating={5} />
<Product title="Amazon Brand - Symbol"price={499}  image='https://m.media-amazon.com/images/I/71Ga6S4898L._AC_UL480_FMwebp_QL65_.jpg' rating={4} />
</div>


            </div>

            
        </div>
    )
}
